import { render, staticRenderFns } from "./dataQuery.vue?vue&type=template&id=2860fc1c"
import script from "./dataQuery.vue?vue&type=script&lang=js"
export * from "./dataQuery.vue?vue&type=script&lang=js"
import style0 from "./dataQuery.vue?vue&type=style&index=0&id=2860fc1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports